import { useEffect, useState } from 'react';
import useIsKioskMode from './useIsKioskMode';
import { exitKiosk } from './kioskExit';

const IDLE_TIMEOUT_MS = 60 * 1000;
const WARNING_DURATION_S = 30;
const ACTIVITY_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'wheel'];

export default function useKioskIdleReset(path, redirectUrl) {
  const isKioskMode = useIsKioskMode();
  const [warningOpen, setWarningOpen] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(WARNING_DURATION_S);

  // Watch for inactivity while the warning isn't showing; once idle too long, open it.
  useEffect(() => {
    if (!isKioskMode || !path || warningOpen) return undefined;

    let timer;
    const restartTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => setWarningOpen(true), IDLE_TIMEOUT_MS);
    };

    restartTimer();
    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, restartTimer);
    });

    return () => {
      clearTimeout(timer);
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, restartTimer);
      });
    };
  }, [isKioskMode, path, warningOpen]);

  // Count down while the warning is open; reset for real if nobody answers in time.
  useEffect(() => {
    if (!warningOpen) return undefined;

    setSecondsLeft(WARNING_DURATION_S);
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          exitKiosk(path, redirectUrl);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [warningOpen, path, redirectUrl]);

  return {
    warningOpen,
    secondsLeft,
    continueSession: () => setWarningOpen(false),
    resetNow: () => exitKiosk(path, redirectUrl),
  };
}
